import { render, staticRenderFns } from "./advance_report_v1.vue?vue&type=template&id=2fc190c6&scoped=true&"
import script from "./advance_report_v1.vue?vue&type=script&lang=js&"
export * from "./advance_report_v1.vue?vue&type=script&lang=js&"
import style0 from "./advance_report_v1.vue?vue&type=style&index=0&id=2fc190c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc190c6",
  null
  
)

export default component.exports